<script>

import { Overlay } from '../../'

export default {
    name: 'ChaikinVolatility',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Chaikin Volatility - Measures volatility based on high-low range',
                preset: {
                    name: 'Chaikin Volatility $ema_length $roc_length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#ff9800'
                    }
                }
            }
        },
        use_for() { return ['ChaikinVolatility'] },
        calc() {
            return {
                props: {
                    ema_length: { def: 10, text: 'EMA Length' },
                    roc_length: { def: 10, text: 'ROC Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let spread = ts(high[0] - low[0])
                    let average = ema(spread, ema_length)
                    return average[roc_length] ? 100 * (average[0] / average[roc_length] - 1) : 0
                `
            }
        }
    }
}
</script>
